import { useNavigate } from "react-router-dom";
import { Category } from "../../../types/Category";
import { trackMetric } from "@ecommerce/analytics";

export const useCategoriesNavigation = (onNavigate?: () => void) => {
    const navigate = useNavigate();

    const handleNavigation = (path: string) => {
        navigate(path);
        onNavigate?.();
    };

    const handleCategoryClick = (category: Category) => {
        trackMetric("CATEGORY_CLICK", { entitySku: category.sku });
        const path = `categoria/${category.sku}`;
        handleNavigation(path);
    };

    const handleViewAllInCategory = (category: Category) => {
        trackMetric("CATEGORY_CLICK", { entitySku: category.sku });
        const path = `categoria/${category.sku}`;
        handleNavigation(path);
    };

    return {
        handleNavigation,
        handleCategoryClick,
        handleViewAllInCategory,
    };
};
